import { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";

export default function Donate() {
  const [form, setForm] = useState({ donor_name: "", email: "", amount: "", purpose: "general", message: "" });
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/donations", { ...form, amount: Number(form.amount) });
      toast.success("Thank you for your generosity!");
      setForm({ donor_name: "", email: "", amount: "", purpose: "general", message: "" });
    } catch { toast.error("Failed to submit"); }
  };
  return (
    <div data-testid="donate-page" className="py-20">
      <div className="max-w-3xl mx-auto px-4 sm:px-6">
        <div className="eyebrow mb-3">Donate</div>
        <h1 className="font-display text-5xl sm:text-6xl uppercase font-bold tracking-tight">Fuel The Mission</h1>
        <p className="text-slate-400 mt-4">Donations support equipment, tournament travel, uniforms, and scholarships for players in need.</p>
        <form onSubmit={submit} className="kr-card rounded-xl p-8 mt-10 space-y-4" data-testid="donate-form">
          <input required placeholder="Your Name" value={form.donor_name} onChange={(e) => setForm({ ...form, donor_name: e.target.value })} className="w-full bg-[#050A15] border border-white/10 rounded-md p-3" />
          <input required type="email" placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="w-full bg-[#050A15] border border-white/10 rounded-md p-3" />
          <input required type="number" placeholder="Amount ($)" value={form.amount} onChange={(e) => setForm({ ...form, amount: e.target.value })} className="w-full bg-[#050A15] border border-white/10 rounded-md p-3" />
          <select value={form.purpose} onChange={(e) => setForm({ ...form, purpose: e.target.value })} className="w-full bg-[#050A15] border border-white/10 rounded-md p-3">
            <option value="general">General Support</option>
            <option value="equipment">Equipment</option>
            <option value="travel">Tournament Travel</option>
            <option value="uniforms">Uniforms</option>
            <option value="scholarships">Player Scholarships</option>
          </select>
          <textarea rows={3} placeholder="Message (optional)" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="w-full bg-[#050A15] border border-white/10 rounded-md p-3" />
          <button className="btn-primary w-full justify-center" data-testid="donate-submit">Submit Pledge</button>
          <p className="text-xs text-slate-500 text-center">Payment processing coming soon. We'll contact you to complete your gift.</p>
        </form>
      </div>
    </div>
  );
}
